import { Component, signal, output, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import { Store } from '@ngrx/store';
import { AuthSelectors } from '@src/app/store/auth/auth.selectors';
import { WebformService } from '@src/app/core/services/webform/webform.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-duplicate-coordinated-card-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    DialogModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './duplicate-coordinated-card.dialog.component.html',
  styleUrls: ['./duplicate-coordinated-card.dialog.component.scss'],
})
export class DuplicateCoordinatedCardDialogComponent extends BaseDialogComponent {
  store = inject(Store);
  user = this.store.selectSignal(AuthSelectors.selectAuthUser);
  sendingRequest = signal(false);

  constructor(
    private messageService: MessageService,
    private translate: TranslateService,
    private webformService: WebformService,
  ) {
    super();
  }

  onConfirm() {
    this.sendingRequest.set(true);
    this.webformService
      .requestDuplicateCoordinatedCard()
      .pipe(finalize(() => this.sendingRequest.set(false)))
      .subscribe({
        next: (data) => {
          if (data.sid) {
            this.showPasswordUpdatedToast();
            this.close();
          }
        },
      });
  }

  private showPasswordUpdatedToast() {
    this.messageService.add({
      severity: 'success',
      life: 5000,
      summary: this.translate.instant('duplicateCard.toast.success.summary'),
      detail: this.translate.instant('duplicateCard.toast.success.detail'),
    });
  }
}
